export const REPORT_ACCENT = '#205bff';
const styles = {
    cover: { color: REPORT_ACCENT, tint: '#eef3ff', label: 'Strategy report' },
    contents: { color: REPORT_ACCENT, tint: '#eef3ff', label: 'Contents' },
    brief: { color: REPORT_ACCENT, tint: '#eef3ff', label: 'Executive brief' },
    foundation: { color: '#8934ed', tint: '#f6eeff', label: 'Foundation' },
    objectives: { color: '#205bff', tint: '#eef3ff', label: 'Objectives' },
    environment: { color: '#16778b', tint: '#edf7fa', label: 'External environment' },
    capabilities: { color: '#6e39b4', tint: '#f4effb', label: 'Capabilities' },
    execution: { color: '#a95520', tint: '#fff4ec', label: 'Execution' },
    decisions: { color: '#304aad', tint: '#eff2fc', label: 'Decisions and actions' },
    appendices: { color: '#566273', tint: '#f1f3f6', label: 'Appendix' },
};
const categories = {
    cover: 'cover',
    'cover-page': 'cover',
    contents: 'contents',
    'toc-page': 'contents',
    'executive-brief': 'brief',
    'executive-summary': 'brief',
    'executive-summary-page': 'brief',
    foundation: 'foundation',
    'foundation-page': 'foundation',
    'vision-mission': 'foundation',
    direction: 'foundation',
    objectives: 'objectives',
    'objectives-page': 'objectives',
    'external-environment': 'environment',
    'external-assessment': 'environment',
    'external-assessment-page': 'environment',
    external: 'environment',
    'swot-capabilities': 'capabilities',
    'internal-assessment': 'capabilities',
    'internal-assessment-page': 'capabilities',
    swot: 'capabilities',
    'swot-page': 'capabilities',
    'execution-progress': 'execution',
    'strategic-execution': 'execution',
    'strategy-execution-page': 'execution',
    'progress-overview-page': 'execution',
    progress: 'execution',
    execution: 'execution',
    decisions: 'decisions',
    recommendations: 'decisions',
    priorities: 'decisions',
    pestel: 'appendices',
    'pestel-page': 'appendices',
    'five-forces': 'appendices',
    'five-forces-page': 'appendices',
    'success-factors': 'appendices',
    'industry-success-factors-page': 'appendices',
    competitors: 'appendices',
    'competitor-analysis-page': 'appendices',
    'driving-forces': 'appendices',
    'driving-forces-page': 'appendices',
};
/** Use the same restrained chapter colours in the editor, report and slide deck. */
export function reportSectionStyle(id) {
    const baseId = id.replace(/^slide-/, '').replace(/(?:-(?:legacy|cont)-\d+)+$/, '');
    const category = categories[baseId];
    return category ? { ...styles[category] } : { ...styles.appendices, label: 'Report section' };
}
